import { gql } from "@apollo/client";

export const CREATE_SANCTION = gql`
  mutation CreateSanction($input: CreateSanctionInput!) {
    createSanction(input: $input) {
      sanction {
        id
        type
        reason
        status
        gamesSuspended
        issuedAt
        profile { id fullName }
        team { id name }
        game { id name }
      }
    }
  }
`;

export const UPDATE_SANCTION = gql`
  mutation UpdateSanction($id: ID!, $input: UpdateSanctionInput!) {
    updateSanction(id: $id, input: $input) {
      sanction {
        id
        type
        reason
        gamesSuspended
        issuedAt
        profile { id fullName }
        team { id name }
        game { id name }
      }
    }
  }
`;

export const DELETE_SANCTION = gql`
  mutation DeleteSanction($id: ID!) {
    deleteSanction(id: $id) {
      success
    }
  }
`;
